module.exports = __webpack_public_path__ + "assets/img/news (44).233bd01d.png";